<template>
    <template v-if="isSearchPage">
        <BlockProductListingLayout :showHeading :overrideTitle="overrideTitle || title" :sortBy />
    </template>
    <template v-else-if="!manufacturer">
        <BlockProductListingContext v-slot="{ category }" :categoryId="categoryId">
            <BlockProductListingLayout :category :showHeading :overrideTitle="overrideTitle || title" :sortBy />
        </BlockProductListingContext>
    </template>
    <template v-else>
        <BlockProductListingLayout :category="category" :showHeading :overrideTitle="overrideTitle || title" :sortBy />
    </template>
</template>

<script setup lang="ts">
    const props = defineProps({
        categoryId: String,
        category: Object,
        showHeading: { type: Boolean, default: true },
        title: { type: String, default: '' },
        overrideTitle: { type: String, default: '' },
        sortBy: { type: String, default: 'name-asc' },
    });

    const route = useRoute();
    const isSearchPage = computed(() => !!route.query.tn_q);
    const manufacturer = useState<string | undefined>(`manufacturer-${route.path}`).value;
</script>
